import { InputAdornment, TextField, useTheme } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import './ViewNumberFormat.scss';
import { isNumber } from 'lodash';
import TypographyElement, { FontWeightTypographyElement } from '../typography/TypographyElement';
import { ColorTypographyElement } from '@/componentShare/theme/dark';

type TextAlign = "center" | "justify" | "left" | "right" | "start" | "end"

type Props = {
    value: string | number | undefined
    align?: TextAlign
    isPercentage?: boolean
    displayType?: "input" | "text"
    color?: ColorTypographyElement
    isCheckPNL?: boolean
    fontWeightElement?: FontWeightTypographyElement
}

const ViewNumberFormat = (props: Props) => {
    const { value, align, isPercentage, color, isCheckPNL, fontWeightElement } = props

    const theme = useTheme()

    let textColor = color ?? 'primary'
    let pv
    if (value === undefined || value === null) {
        pv = 0
    } else {
        pv = Number.parseFloat(value.toString())
    }

    if (isCheckPNL === true) {
        if (isNumber(value)) {
            if (Number.parseFloat(value.toString()) > 0) {
                textColor = 'up'
            } else {
                textColor = 'down'
            }
        }
    }

    return (
        <>
            <NumericFormat
                displayType={props?.displayType ?? 'input'}
                className='mf-number-format'
                value={pv}
                readOnly={true}
                disabled={true}
                customInput={TextField}
                thousandSeparator
                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, '& .MuiInputBase-input': { color: `${theme.palette.text[textColor]} !important`, fontWeight: fontWeightElement ?? 400 } }}
                slotProps={{
                    htmlInput: {
                        sx: {
                            textAlign: align ? align : 'start', color: theme.palette.text[textColor]
                        }
                    },
                    input: {
                        endAdornment: isPercentage === true ? <InputAdornment position="end">%</InputAdornment> : undefined,
                    }

                }}
                style={props?.displayType === 'text' ? { color: theme.palette.text[textColor], fontWeight: fontWeightElement ?? 400 } : {}}
                size={'small'}
                decimalScale={isPercentage ? 2 : undefined}
            />
            {isPercentage && props?.displayType === 'text' && <TypographyElement sx={{ fontSize: "inherit" }} component={'span'} ColorElement={textColor}>%</TypographyElement>}
        </>

    )
}

export default ViewNumberFormat





